import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["loading"]

import {nextTick,reactive, UnwrapRef, watch} from "vue";
import {getTreatTypes} from "@/api/sale_order";
interface Data {
    loading: boolean;
    dataOptions: any[],
    selectedTreat: number
}

export default /*#__PURE__*/_defineComponent({
  __name: 'selectTreat',
  props: {
    patientId: {
        type: String,
        default: "0"
    },
},
  emits: ['selectChange'],
  setup(__props, { emit: emits }) {

const props = __props;


const data: UnwrapRef<Data> = reactive({
    loading: false,
    dataOptions: [
    ],
    selectedTreat:0
})


watch(
    () => props.patientId, async () => {
        await nextTick(()=>{
             onSearch();
        })
    },
    {
    immediate: true,
    deep: true,
    }
);
const onSearch = () => {
    getTreatTypes(props.patientId).then((res: any[])=>{
        data.dataOptions = res;
    })
}
const selectedTreat = (value: Event)=>{
    console.log(data.selectedTreat)
    if(value){
        let res = {
            id: data.selectedTreat,
            name: data.dataOptions.filter(e=>{
                return e.value == data.selectedTreat
            })[0].label,
            type: 2,
        }
        console.log(res,"开始回传")
        emits("selectChange",res)
    }
}



return (_ctx: any,_cache: any) => {
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", {
    loading: data.loading
  }, [
    _createVNode(_component_a_card, { bordered: false }, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: data.selectedTreat,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((data.selectedTreat) = $event)),
                  "button-style": "solid",
                  onChange: selectedTreat,
                  options: data.dataOptions
                }, null, 8, ["value", "options"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 8, _hoisted_1))
}
}

})